import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import instance from "../../../config/Config";

const initialState = {
    data: null,
    loading: false,
    error: null,
    count: null,
};

export const fetchDesignationList = createAsyncThunk(
    "fetchDesignationList",
    async (body) => {
        try {
            const response = await instance.get(
                `/remark/designation/designation-list?page=${body.page}&search=${body.search}`
            );
            return response.data;
        } catch (error) {
            throw error;
        }
    }
);


export const DesignationSlice = createSlice({
    name: "DesignationSlice",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(fetchDesignationList.pending, (state, action) => {
            state.loading = true;
        });
        builder.addCase(fetchDesignationList.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
            state.count = action.payload?.count;


        });
        builder.addCase(fetchDesignationList.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });
    },
});

export default DesignationSlice.reducer;
